import { InternalAxiosRequestConfig } from 'axios';

import { useUserStore } from '@/store/user-store';

export const attachSiteToken = (config: InternalAxiosRequestConfig) => {
  const siteToken = useUserStore.getState().siteToken;

  if (config.skipAttachSiteToken) {
    return config;
  }

  if (siteToken) {
    config.headers['s-site-token'] = siteToken;
  }

  return config;
};
